import React from "react";

import { ErrorMessage } from "formik";

export default function InputErrorMessage({ name }) {
  return (
    <ErrorMessage
      name={name}
      render={(message) => <div className="text-sm text-danger">{message}</div>}
    />
  );
}
